import { useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import StatsRankings from '../components/StatsRankings';
import USPGrid from '../components/USPGrid';
import ProgramOverview from '../components/ProgramOverview';
import CurriculumOverview from '../components/CurriculumOverview';
import AdmissionJourney from '../components/AdmissionJourney';
import OutcomesCharts from '../components/OutcomesCharts';
import ImageGallery from '../components/ImageGallery';
import CompanyLogos from '../components/CompanyLogos';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import StickyApplyBar from '../components/StickyApplyBar';
import LeadModal from '../components/LeadModal';
import Analytics from '../components/Analytics';
import { outcomesData } from '../lib/iit-outcomes';
import Banner from '../components/Banner';
import WhyChicago from '../components/WhyChicago';

export default function App() {
  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  return (
    <>
      <Header onApplyClick={openModal} />
      <main>
        <Hero onApplyClick={openModal} />
        <StatsRankings />
        <Banner />
        <USPGrid />
        <ProgramOverview />
        <CurriculumOverview  />
        <WhyChicago onApplyClick={openModal} />
        <AdmissionJourney onApplyClick={openModal} />
        <OutcomesCharts data={outcomesData} />
        <CompanyLogos />        
        <ImageGallery />
        <FAQ />
      </main>
      <Footer />
      <StickyApplyBar onApplyClick={openModal} />
      <LeadModal open={modalOpen} onClose={closeModal} />
      <Analytics />
    </>
  );
}
